import React from "react";
import { format, parseISO } from "date-fns";
import { Slider } from "../../ui/Slider";

const formatScrubTime = (timestamp) => {
  if (!timestamp) return "—";
  try {
    return format(parseISO(timestamp), "MMM d, yyyy HH:mm") + " UTC";
  } catch {
    return timestamp;
  }
};

const TimeScrubber = ({
  timeline,
  timeIndex,
  onTimeIndexChange,
  disabled,
  className = "",
}) => {
  const maxIndex = Math.max(0, timeline.length - 1);
  const selectedTimestamp = timeline[timeIndex] ?? null;
  const isLive = timeIndex >= maxIndex;

  if (!timeline.length) {
    return (
      <div className={`px-4 py-3 text-sm text-gray-500 border-t border-gray-200 bg-white ${className}`}>
        Load metrics to scrub through time.
      </div>
    );
  }

  return (
    <div className={`px-4 py-3 border-t border-gray-200 bg-white ${className}`}>
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <span className="text-sm font-medium text-ktx-purple">
          {formatScrubTime(selectedTimestamp)}
        </span>
        <div className="flex items-center gap-2">
          {!isLive && (
            <button
              type="button"
              onClick={() => onTimeIndexChange(maxIndex)}
              className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50"
            >
              Jump to now
            </button>
          )}
          {isLive && (
            <span className="text-xs px-2 py-0.5 rounded-full bg-green-100 text-green-800">
              Latest
            </span>
          )}
        </div>
      </div>
      <Slider
        value={[timeIndex]}
        onValueChange={(value) => onTimeIndexChange(value[0])}
        min={0}
        max={maxIndex}
        step={1}
        disabled={disabled || timeline.length <= 1}
        className="w-full cursor-pointer"
      />
      <div className="flex justify-between mt-2 text-xs text-gray-500">
        <span>{formatScrubTime(timeline[0])}</span>
        <span>{formatScrubTime(timeline[maxIndex])}</span>
      </div>
    </div>
  );
};

export default TimeScrubber;
